const formatPrePaidCardLastFour = (number, zeroFillSize): string => {
	const limitedNumber = number.toString().slice(-4);
	return limitedNumber.padStart(zeroFillSize, "0");
};

export default formatPrePaidCardLastFour;
